var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classObject,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon-btn__icon"},[_vm._t("default"),(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"size":_vm.size}}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }